
import { mapState, mapMutations } from "vuex";
import { About } from "@/graphql/about";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
export default {
  components: {
    VueSlickCarousel,
  },
  nuxtI18n: {
    paths: {
      "en-ca": "/about-us",
      "fr-ca": "/a-propos",
    },
  },
  async asyncData({ app, i18n }) {
    const client = app.apolloProvider.defaultClient;
    const locale = i18n.locale.slice(0, 3) + i18n.locale.slice(3).toUpperCase();
    const aboutResponse = await client.query({
      query: About,
      variables: { locale: locale },
    });
    const aPropo = aboutResponse.data.pageAPropos.data.attributes;
    return { aPropo };
  },
  data() {
    return {
      aPropo: {},
      show: false,
      anchorSelected: "",
      historyBlock: {
        currentDate: "",
        prevDate: "",
        nextDate: "",
        title: "",
        text: "",
      },
      carouselSettings: {
        arrows: false,
        centerMode: true,
        focusOnSelect: true,
        infinite: false,
        centerPadding: "0px",
        variableWidth: true,
        swipe: false,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              swipe: true,
            },
          },
        ],
      },
      slidesNumber: "",
    };
  },
  head() {
    return {
      title: this.aPropo.SEO.MetaTitle,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.aPropo.SEO.MetaDescription,
        },
        {
          hid: "og:description",
          name: "og:description",
          content: this.aPropo.SEO.MetaDescription,
        },
      ],
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    setTimeout(() => this.setPageAnimation("animBanner"), 500);
  },
  computed: {
    ...mapState(["pageScroll"]),
  },
  methods: {
    ...mapMutations({
      setPageAnimation: "SET_PAGE_ANIMATION",
    }),
    handleInit() {
      this.slidesNumber = this.aPropo.Annees.length;
      this.historyBlock.prevDate = "";
      this.historyBlock.currentDate = this.aPropo.Annees[0].Year;
      this.historyBlock.nextDate = this.aPropo.Annees[1].Year;
      this.historyBlock.title = this.aPropo.Annees[0].Titre;
      this.historyBlock.text = this.aPropo.Annees[0].Texte;
    },
    handleAfterChange(currentSlide) {
      this.getPreviousDate(currentSlide);
      this.getNextDate(currentSlide);
      this.historyBlock.currentDate = this.aPropo.Annees[currentSlide].Year;
      this.historyBlock.title = this.aPropo.Annees[currentSlide].Titre;
      this.historyBlock.text = this.aPropo.Annees[currentSlide].Texte;
    },
    showPrev() {
      this.$refs.carousel.prev();
    },
    showNext() {
      this.$refs.carousel.next();
    },
    getPreviousDate(currentSlide) {
      if (currentSlide > 0) {
        this.historyBlock.prevDate = this.aPropo.Annees[currentSlide - 1].Year;
      } else {
        this.historyBlock.prevDate = "";
      }
    },
    getNextDate(currentSlide) {
      if (currentSlide != this.slidesNumber - 1) {
        this.historyBlock.nextDate = this.aPropo.Annees[currentSlide + 1].Year;
      } else {
        this.historyBlock.nextDate = "";
      }
    },
  },
};
